export default "__VITE_ASSET__CXfCMxr$__"